// extracted by mini-css-extract-plugin
export default {"FooterNav":"FooterNav_FooterNav__PsQNI","footerNav_link":"FooterNav_footerNav_link__FT4YS"};